import { QueryInputType, getClasses, queryInput } from '@/utils';

import ActivityList from '@/common/Activity/ActivityList';
import { ActivityType } from '@/api/services/activity/SearchActivity';
import CombineDiscountForm from '../CombineDiscountForm';
import { LoadingBlur } from '@/components/LoadingSpinner';
import Popup from '@/common/Popup';
import { PopupTypes } from '@/common/Popup/types';
import { SortDirectionEnum } from '@/models/gen/graphql';
import { createComponentState } from '@/state';
import { useEffect } from 'react';
import { useSearchCombineRuleHistory } from '../../api/services/combineRule/searchCombineRuleHistoryBulk';

export type CombineDiscountDrawerState = {
  show: boolean;
  data: Partial<any>;
};
export const initCombineDiscountDrawerState: CombineDiscountDrawerState = {
  show: false,
  data: {},
};
export const useCombineDiscountDrawer = createComponentState<CombineDiscountDrawerState>(initCombineDiscountDrawerState);
export type CombineDiscountDrawerProps = { locale?: Record<string, string> } & PopupTypes.Props;

const CombineDiscountDrawer = ({ locale: customLocale, ...drawerProps }: CombineDiscountDrawerProps): JSX.Element => {
  const [state, setState] = useCombineDiscountDrawer(({ state, setState }) => [state, setState]);
  const { show, data } = state;
  const { combineRuleId } = data || {};
  const [{ data: value, loading }, { refetch }] = useSearchCombineRuleHistory();

  useEffect((): void => {
    if (!combineRuleId || !show) return;
    refetch([{ combineRuleId: queryInput(combineRuleId), startDatetime: queryInput([], QueryInputType.ISNOTNULL, SortDirectionEnum.Asc) }]);
  }, [combineRuleId]);

  const onHide = async (): Promise<void> => {
    try {
      setState({ show: false, data: undefined });
    } catch (err) {
      console.error('Error hiding drawer:', err);
    }
  };
  const onExited = (): void => setState(initCombineDiscountDrawerState);

  return (
    <Popup
      {...drawerProps}
      className={getClasses('CombineDiscountDrawer', drawerProps.className)}
      show={show}
      onHide={onHide}
      onExited={onExited}
    >
      <LoadingBlur loading={loading} />
      {!loading && <CombineDiscountForm value={{ items: value?.rows, airline: data?.airline, combineRuleId }} onCancel={onHide} />}
      {/* <CombineDiscountHistory entries={[{}]} /> */}
      <ActivityList type={ActivityType.COMBINE_RULE_HISTORY} parentResourceId={combineRuleId || ''} />
    </Popup>
  );
};

export default CombineDiscountDrawer;
